import { useParams } from "react-router-dom";
import { selectS3PathFromPeriod } from "../../../services/submissionPeriod/slices";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { selectByQuestionId } from "../../../services/storage/slices";
import Switch from "../Question/Switch";

const selectByS3Path = createSelector(
  [
    (state, year, period, formType) =>
      selectS3PathFromPeriod(state, year, period, formType),
    (state) => state,
    (state, year, period, formType, questionId) => questionId,
  ],
  (s3Path, state, questionId) => {
    const info = selectByQuestionId(state, { path: s3Path, questionId });
    return info;
  }
);
function PreviewQuestion({ id }) {
  const { year, period, formType } = useParams();
  const question = useSelector((state) =>
    selectByS3Path(state, year, period, formType, id)
  );

  return <Switch {...(question || {})} />;
}

export default PreviewQuestion;
